<div class="content-wrapper p-40px">
  <div class="d-flex bd-highlight">
    <div class="me-auto bd-highlight"><h4>Summary</h4></div>

    <ul *ngIf="this.userType === 'ADMIN' && [companies.Sea, companies.Seca].includes(company)"
        class="nav nav-pills mb-3" id="pills-tab" role="tablist">
      <li class="nav-item tab-btn-container" role="presentation">
        <button
          (click)="switchTab('DEALER')"
          [ngClass]="{
            'nav-link': true,
            'tab-btn-active': tab === 'DEALER',
            'tab-btn': tab !== 'DEALER',
            'px-0': true
          }"
          id="DealerViewTab"
          role="tab"
          type="button">
          Dealer view
        </button>
      </li>
      <li class="nav-item tab-btn-container" role="presentation">
        <button
          (click)="switchTab('AGENT')"
          [ngClass]="{
            'nav-link': true,
            'tab-btn-active': tab === 'AGENT',
            'tab-btn': tab !== 'AGENT',
            'px-0': true
          }"
          id="AgentViewTab"
          role="tab"
          type="button">Agent view
        </button>
      </li>
    </ul>
  </div>
  <div class="d-flex bd-highlight justify-content-between pb-36px">
    <div class="d-flex flex-row bd-highlight">
      <form (keydown.enter)="$event.preventDefault()" [formGroup]="detailForm">
        <div class="col-lg-5 position-relative mr-4px">
          <ng-select (change)="changeDealer($event)"
                     [items]="dealerSelectGroup"
                     [multiple]="false"
                     bindLabel="name"
                     bindValue="code"
                     class="form-control width-form"
                     formControlName="dealer"
                     placeholder="All Dealers">
          </ng-select>
        </div>
      </form>
      <div class="col-lg-5 mr-4px">
        <div class="input-group input-calendar-condition">
          <input
            #startDatePicker="bsDatepicker"
            [bsConfig]="bsConfig"
            [formControl]="startDate"
            [maxDate]="startMaxDate"
            [readOnly]="true"
            bsDatepicker
            class="form-control input-search-condition py-2"
            placement="bottom"
            type="text"/>
          <span class="input-group-text bg-transparent">
                  <img (click)="startDatePicker.toggle()"
                       [attr.aria-expanded]="startDatePicker.isOpen"
                       class="duration-icon"
                       src="assets/img/ico-duration.svg"/>
                </span>
        </div>
      </div>
      <div class="col-lg-5">
        <div class="input-group input-calendar-condition">
          <input
            #endDatePicker="bsDatepicker"
            [bsConfig]="bsConfig"
            [formControl]="endDate"
            [maxDate]="today"
            [readOnly]="true"
            bsDatepicker
            class="form-control input-search-condition py-2"
            placement="bottom"
            type="text"/>
          <span class="input-group-text bg-transparent">
                  <img (click)="endDatePicker.toggle()"
                       [attr.aria-expanded]="endDatePicker.isOpen"
                       class="duration-icon"
                       src="assets/img/ico-duration.svg"/>
                </span>
        </div>
      </div>
      <div class="col-lg-2 mt-6px ml-8px">
        <div class="position-relative">
          <button (click)="reset()"
                  class="btn btn-primary btn-sm"
                  type="submit">Reset
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="[companies.Sea].includes(company)" class="d-flex flex-row bd-highlight">
      <div class="bd-highlight mr-8px">
        <button (click)="switchView('STATUS')"
                [ngClass]="{
                  'btn': true,
                  'btn-sort-primary': view === 'STATUS',
                  'btn-sort-outline': view !== 'STATUS'
                }"
                type="button">
          <i class="fa-duotone fa-loader"></i>
          STATUS
        </button>
      </div>
      <div class="bd-highlight">
        <button (click)="switchView('DATE')"
                [ngClass]="{
                  'btn': true,
                  'btn-sort-primary': view === 'DATE',
                  'btn-sort-outline': view !== 'DATE'
                }"
                type="button">
          <i class="fa-light fa-calendar-days"></i>
          DATE
        </button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="view === 'STATUS'; else isDateViewTemp">
    <app-status-view [setSummaryStatusData]="summaryStatusData" [tabName]="tab"></app-status-view>
  </ng-container>
  <ng-template #isDateViewTemp>
    <app-date-view [setSummaryDateData]="summaryDateData" [tabName]="tab"></app-date-view>
  </ng-template>
</div>

